
import Less from 'less'
import './summary/assets/css/base.less'
import 'font-awesome/css/font-awesome.min.css'
import ElementUI from 'element-ui'
import '@babel/polyfill'

import '../static/js/wxLogin.js'//引入微信js

import 'element-ui/lib/theme-chalk/index.css'
import '../static/font_icon/iconfont.css'
import global_ from './GLOBAL.vue'
import VueAMap from 'vue-amap';
import Axios from "axios";
import  VueResource  from 'vue-resource'
import qs from "qs";
import VueParticles from 'vue-particles'
import VueBus from 'vue-bus';
import SlideVerify from '../static/puligin/vue-monoplasty-slide-verify/index.js';
import Meta from 'vue-meta'
// import CKEditor from 'ckeditor4-vue';

import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import router from './router'

// import CKEditor from '@ckeditor/ckeditor5-vue2';
// Vue.use( CKEditor );

//引入vueXconfig
import store from './vuex/store'
//引入socket
import VueSocketIO from 'vue-socket.io'
import '../static/css/klm.less'

// 处理数据为图片添加后缀
function processimgurl (url,w=2000,h=2000,qntype = 2) {
	let str;
	if (url) {
		let strurl = url.split('?')[0]
		if (url.includes('yimgs.kuleiman.com')) {
			str = `${strurl}?x-oss-process=image/resize,w_${w},${h?`h_${h},`:''}m_lfit`
		} else{
			str = `${strurl}?imageView2/${qntype}/w/${w}${h?`/h/${h}`:''}`
		}
	}
	console.log('processimgurl',str)
	return str
}

Vue.use(VueParticles);
Vue.prototype.$axios = Axios;
Vue.prototype.$qs=qs;
Vue.prototype.$processimgurl=processimgurl;
Vue.config.productionTip = false;
Vue.prototype.GLOBAL=global_;
Vue.use(ElementUI);
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.use(Vuex);
Vue.use(VueAMap);
Vue.use(VueResource);
Vue.use(VueBus);
Vue.use(SlideVerify);
Vue.use(Meta)
// CKEditor.plugins.add("select_klm",{
//     init:function(editor){

//     }
// })
// CKEditor.on('dialogDefinition',function(ev){
//     console.log("显示弹窗",ev.data.name);
// })

// Vue.use( CKEditor );

let bus = new Vue();
Vue.prototype.bus = bus;
let map_config = {
    key:global_.amap_key,
    plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar',
        'AMap.MapType', 'AMap.PlaceSearch', 'AMap.Geolocation',
        'AMap.Geocoder','AMap.MouseTool','AMap.RectangleEditor'],
    v: '1.4.4',
    uiVersion: '1.0',
    version:'2.0',

}
if(global_.amap_securityJsCode){
    // map_config.securityJsCode = global_.amap_securityJsCode;
    // map_config.key = global_.amap_key + '&securityJsCode=' + global_.amap_securityJsCode;
    window._AMapSecurityConfig = {
        securityJsCode:global_.amap_securityJsCode
    }
}
console.log(map_config)
VueAMap.initAMapApiLoader(map_config);
// 设置服务器代理
Axios.defaults.baseURL = '/api';
// 接口返回拦截器
Axios.interceptors.response.use(
	response => {
		if(response.data.status == 1000) {
			if(response.config.url.split('/')[1] == 'member') {
				// 终端
                //这边再次做出判断
                if(window.location.search.indexOf('merchant_pid')!=-1){
                    window.location.href = "http://vrr.kuleiman.com/index.php"+window.location.search;

                }else{
                    window.location.href = "/member/login?target_url="+window.location.pathname + window.location.search.replace("&","_and__");
                }

			} else if(response.config.url.split('/')[1] == 'agent') {
				// 合作商
                window.location.href = "/agent/login";

			} else if(response.config.url.split('/')[1] == 'admin') {
				// 总后台
                window.location.href = "/summary/login";
			}
		}
        if(response.data.status == 1001){
            if(response.config.url.split('/')[1] == 'member') {
                // 终端
                window.location.href = "/member/login?status=timeout";

            } else if(response.config.url.split('/')[1] == 'agent') {
                // 合作商
                window.location.href = "/agent/login?status=timeout";

            } else if(response.config.url.split('/')[1] == 'admin') {
                // 总后台
                window.location.href = "/summary/login?status=timeout";
            }
        }

		return response
	},
	error => {
	 return Promise.reject(error)
	}
)
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
})
Vue.use(new VueSocketIO({

	debug: false,

	connection: global_.SocketIO_url,  //

}))
const setFontSize = () => {
	const htmlDom = document.getElementsByTagName('html')[0]
	let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
	if (htmlWidth >= 750) {
	  htmlWidth = 828
	}
	if (htmlWidth <= 320) {
	  htmlWidth = 320
	}
	htmlDom.style.fontSize = `${htmlWidth / 8.28}px`
  }
  window.onresize = setFontSize
  setFontSize()



// WEBPACK FOOTER //
// ./src/main.js